var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77383 4.91874C11.1321 4.91874 12.2332 3.81764 12.2332 2.45937C12.2332 1.1011 11.1321 0 9.77383 0C8.41555 0 7.31445 1.1011 7.31445 2.45937C7.31445 3.81764 8.41555 4.91874 9.77383 4.91874Z",
    fill: "#F4944D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6232 13.0256C14.5221 12.0732 14.2766 11.1675 13.9936 10.2695C13.9944 10.2703 13.9952 10.2707 13.996 10.2711C14.9448 11.0548 15.9567 11.6816 17.1574 11.9919C18.5243 12.3445 19.1027 10.2361 17.7386 9.88392C15.7965 9.38279 14.535 7.69343 12.8303 6.72498C11.7415 5.01187 8.55643 6.1035 9.13847 8.42078C9.22783 8.7766 9.33973 9.13122 9.46008 9.48503C9.02818 10.0469 8.43729 10.4177 7.63387 10.3718C7.11543 10.3416 6.7906 10.6197 6.65455 10.986H5.75291V11.5326H6.59095C6.62074 11.8228 6.74753 12.1054 6.97495 12.301L5.48242 23.2289L6.02421 23.3034L7.4946 12.5361C7.54049 12.5446 7.58436 12.5546 7.63427 12.5578C8.60272 12.6138 9.49913 12.301 10.2398 11.7576C10.4181 12.367 10.5501 12.9829 10.571 13.6144C10.5767 13.7734 10.5972 13.9212 10.6298 14.06C9.88071 14.5756 9.17752 15.1585 8.5355 15.7808C6.5354 17.7197 8.65264 19.9106 9.66496 21.7895C10.5006 23.3408 12.8597 21.9618 12.0241 20.4113C11.6655 19.7456 11.2493 19.1205 10.8459 18.4813C10.6632 18.1906 10.6246 17.5945 10.336 17.8525C10.5203 17.646 10.73 17.4597 10.9341 17.2749C11.4888 16.7742 12.1497 16.2586 12.8376 15.8432C13.7895 18.2422 14.7008 20.6581 15.6073 23.0736C16.2195 24.7082 18.8629 24.0006 18.2426 22.347C17.07 19.2291 15.8895 16.1088 14.6232 13.0256Z",
    fill: "#F4944D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97495 10.9858H5.75291V11.5325H6.59095C6.62074 11.8227 6.74753 12.1052 6.97495 12.3009L5.48242 23.2288L6.02421 23.3032L7.4946 12.5359C7.54048 12.5444 7.58436 12.5544 7.63427 12.5577",
    stroke: "#F4944D",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progress-icon.801269f51da6de7f6d0d09596c0fb7d3.svg";
export { ForwardRef as ReactComponent };